import type { SerializedMeter } from '@enmon/commons/lib/enmon';
import { Tooltip } from 'antd';
import { Icon } from 'components/icon';
import type { VFC } from 'react';
import { useTheme } from 'styled-components';

export const MeterLink: VFC<{
  backend_gateway_meter_id: SerializedMeter['_id'];
}> = ({ backend_gateway_meter_id }) => {
  const theme = useTheme();

  return (
    <Tooltip title="Meter active - Click to open in Enmon">
      <a
        href={`https://${
          window.location.href.includes('app.enmon') ? 'app.enmon' : 'dev.enmon'
        }.tech/establishments/meters/detail/${backend_gateway_meter_id}`}
        rel="noreferrer"
        target="_blank"
      >
        <Icon fixedWidth $fontSize="16px" color={theme.color.core.blue.main['500']} iconString="cloudUpload" />
      </a>
    </Tooltip>
  );
};
